export default __webpack_public_path__ + "static/media/talk.a0b92ae1.png";